import { ReactNode } from 'react'

import { ButtonType, LinkType } from '@/lib/models/components/buttonLink.types'

import { ButtonLinkExternal } from './ButtonLinkExternal.component'
import { ButtonLinkInternal } from './ButtonLinkInternal.component'

interface ButtonLinkProps {
  children?: ReactNode
  linkUrl: string
  className?: string
  buttonType?: ButtonType
  linkType: LinkType
  ariaLabel?: string
  noIcon?: boolean
}

export const ButtonLink = ({
  linkType,
  linkUrl,
  buttonType,
  children,
  className,
  ariaLabel,
  noIcon = false,
}: ButtonLinkProps) => {
  if (linkType === LinkType.INTERNAL) {
    return (
      <ButtonLinkInternal
        noIcon={noIcon || false}
        linkUrl={linkUrl}
        className={className}
        buttonType={buttonType}
        ariaLabel={ariaLabel && ariaLabel}
      >
        {children}
      </ButtonLinkInternal>
    )
  }

  if (linkType === LinkType.EXTERNAL) {
    return (
      <ButtonLinkExternal
        noIcon={noIcon || false}
        linkUrl={linkUrl}
        className={className}
        buttonType={buttonType}
      >
        {children}
      </ButtonLinkExternal>
    )
  }

  return null
}
